var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5875 6.05C12.4625 6.05 11.45 5.5875 10.7125 4.85V10.5125C10.7125 12.8 8.85 14.6625 6.5625 14.6625C4.275 14.6625 2.4125 12.8 2.4125 10.5125C2.4125 8.225 4.275 6.3625 6.5625 6.3625C6.775 6.3625 6.975 6.3875 7.175 6.425V8.7375C6.975 8.675 6.775 8.6375 6.5625 8.6375C5.525 8.6375 4.6875 9.475 4.6875 10.5125C4.6875 11.55 5.525 12.3875 6.5625 12.3875C7.6 12.3875 8.525 11.575 8.525 10.5125L8.5375 1.3375H10.7C10.7 1.3375 10.7125 1.3375 10.7125 1.35C10.7125 2.7875 11.8875 3.9625 13.325 3.9625C13.4125 3.9625 13.5 3.955 13.5875 3.9425V6.05Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIcon);
export default __webpack_public_path__ + "static/media/tiktok-icon.99616c760460c41e063d275f3891d0df.svg";
export { ForwardRef as ReactComponent };